(function () {
  class Freespins {
    constructor() {
      var self = this;
      this._startHolder = undefined;
      this._endHolder = undefined;
      this._fsCountText = undefined;
      this._fsWinningsMeter = undefined;
      this._fsActive = false;
      this._freespinsCount = 0;
      this._spinsLeft = 0;
      this._outroPopup = undefined;
      this._outroPopupButton = undefined;
      this._winningsThisSpin = 0;
      this.mushroomWinThisSpin = false;

      this._freespinsTune = undefined;

      this._doSpinFunc = this.doSpin.bind(this);
      this._doSpinDeadFunc = this.doSpinDead.bind(this);
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEvent",
        this.onFreespinsStart.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsStartEventDead",
        this.onFreespinsStartDead.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsDataEvent",
        this.onFreespinsData.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsDataEventDead",
        this.onFreespinsDataDeadEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsRetriggerEvent",
        this.onFreespinsRetriggerEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsEndEvent",
        this.onFreespinsEndEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:WinningLinesEvent",
        this.doPayWins.bind(this)
      );
      this._payWinsDeadFunc = this.doPayWinsDead.bind(this);
      messageBus.subscribe(
        "bountyhunter:skipWins",
        this.skipAnimations.bind(this)
      );
      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
      Reflex.registerEventHandler(
        "layoutChange",
        this.onLayoutChange.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsAwardEventDead",
        this.onFreespinsAwardedEnd.bind(this)
      );
      messageBus.subscribe(
        "mushroom:mushroomResultsDead",
        this.onMushroomResultsEventDead.bind(this)
      );

      StateMachine.Create(this);
      Reflex.addToUpdate(function (delta, time) {
        self.update(delta, time);
      });

      this.stateMachine.addState("IDLE", function () {});
      this.stateMachine.addState("OUTRO", function () {
        self.update_outroState();
      });
      this.stateMachine.addState("OUTRO_POPUP", function () {
        self.update_outroPopupState();
      });
    }

    update(delta, time) {
      if (this.stateMachine) {
        this.stateMachine.update();
      }
    }

    skipAnimations() {}

    onOrientationChange() {
      if (this._fsActive) {
        this._logo.visible = false;
        if (this._bg !== undefined) {
          this._bgLandscape.alpha = this._bg.alpha;
          this._bgPortrait.alpha = this._bg.alpha;
          this._bgLandscape.visible = this._bg.visible;
          this._bgPortrait.visible = this._bg.visible;
          switch (layoutController.getCurrentLayout()) {
            case "landscape_default":
            case "landscape_mobile": {
              this._bgPortrait.alpha = 1;
              this._bgPortrait.visible = false;
              this._bg = this._bgLandscape;
              break;
            }
            case "portrait_default":
            case "portrait_mobile": {
              this._bgLandscape.alpha = 1;
              this._bgLandscape.visible = false;
              this._bg = this._bgPortrait;
              break;
            }
          }
        }
        const fsCreditMeterPos = resourceManager.get(
          "creditContainer_freespinsPosition"
        ).position;
        this._baseCreditMeterContainer.position.set(
          fsCreditMeterPos.getX(),
          fsCreditMeterPos.getY()
        );
        const fsStakeMeterPos = resourceManager.get(
          "betContainer_freespinsPosition"
        ).position;
        this._baseStakeMeterContainer.position.set(
          fsStakeMeterPos.getX(),
          fsStakeMeterPos.getY()
        );
      }
    }

    onLayoutChange() {
      if (this._fsActive) {
        this.onOrientationChange();
      }
    }

    hideAllAnimations() {}

    update_outroPopupState() {
      if (this.phase.enter()) {
        this._outroPopup.visible = true;
        this._outroPopup.alpha = 0;
        soundManager.stop("FreespinsMusic");
        soundManager.play("hbc_whoosh_v1");
      }

      if (this.phase.timed(500)) {
        this._popupMaskDimObject.show(true, this.phase.Progress);
        this._outroPopup.alpha = this.phase.Progress;
      }

      if (this.phase.once()) {
        this._outroPopup.alpha = 1;
        this._outroPopupButton.interactive = true;
        const self = this;
        this._outroPopupButton.touchend = this._outroPopupButton.mouseup =
          function () {
            self.stateMachine.switchState("OUTRO");
            self._outroPopupButton.interactive = false;
            self._outroPopupButton.touchend = self._outroPopupButton.mouseup =
              function () {};
          };
      }
    }

    update_outroState() {
      if (this.phase.enter()) {
        this._logo.alpha = 0;

        switch (layoutController.getCurrentLayout()) {
          case "landscape_default":
          case "landscape_mobile": {
            this._logo.visible = true;
            break;
          }
        }

        this._popupMaskDimObject.show(false);
        this._outroPopup.alpha = 1;
        this._outroPopup.visible = false;
        gameData.winningsMeter.set(this._winnings);
      }

      if (this.phase.timed(1000)) {
        const progress = this.phase.Progress;
        this._freespinElements.forEach(function (element) {
          element.alpha = 1 - progress;
        });
        this._logo.alpha = progress;

        this._bg.alpha = 1 - progress;
      }

      if (this.phase.once()) {
        const fsCreditMeterPos =
          layoutController.getCurrentPosition("creditContainer");
        this._baseCreditMeterContainer.position.set(
          fsCreditMeterPos.x,
          fsCreditMeterPos.y
        );
        const fsStakeMeterPos =
          layoutController.getCurrentPosition("betContainer");
        this._baseStakeMeterContainer.position.set(
          fsStakeMeterPos.x,
          fsStakeMeterPos.y
        );

        this._bg.alpha = 1;
        this._bg.visible = false;

        resourceManager.getContainer("freespinsContainer").visible = false;
        this.stateMachine.switchState("IDLE");
      }

      if (this.phase.exit()) {
        this._endHolder.leave();
        this._fsActive = false;
        this._fsCountText.visible = false;
        resourceManager.getController("inputOverlord").setState("enabled");
        gameController.freespinsComplete(this._endHolder.data.fsWinnings);
      }
    }

    onGameConfigEvent() {}

    playIntroPopupTitleAnim() {
      this._introPopupTitleAnim.gotoAndPlay(0);
    }

    updateCountText() {
      if (this._fsActive) {
        this._fsCountText.setTranslationParameters(
          this._freespinsCount - this._spinsLeft,
          this._freespinsCount
        );
        this._fsCountText.visible = true;
      }
    }

    doSpin(spinTask) {
      this._winningsThisSpin = 0;

      if (spinTask.data.mushroomResults !== undefined) {
        this.mushroomWinThisSpin = true;
      } else {
        this.mushroomWinThisSpin = false;
      }
      ///this.updateCountText();
    }

    doSpinDead(spinTask) {}

    getNextSpinOutcome() {
      this.updateCountText();
      gameController.initNewSpin();
      gdk.getNextGameOutcome(function () {});
    }

    sortOutLayout() {
      switch (layoutController.getCurrentLayout()) {
        case "landscape_default": {
          resourceManager.get("freespinsTimeBackground").visible = true;
          resourceManager.get("freespinsStake").visible = true;
          resourceManager.get("freespinsCredit").visible = true;
          break;
        }
        case "portrait_default":
        case "portrait_mobile": {
          resourceManager
            .get("slotContainer")
            .position.setY(
              layoutController.getCurrentPosition("slotContainer").y - 150
            );
          resourceManager.get("freespinsTimeBackground").visible = false;
          resourceManager.get("freespinsStake").visible = false;
          resourceManager.get("freespinsCredit").visible = false;
          break;
        }

        case "landscape_mobile": {
          resourceManager
            .get("slotContainer")
            .position.setX(
              layoutController.getCurrentPosition("slotContainer").x + 50
            );
          resourceManager.get("freespinsTimeBackground").visible = false;
          resourceManager.get("freespinsStake").visible = false;
          resourceManager.get("freespinsCredit").visible = false;
          break;
        }
      }
    }

    onFreespinsStart(task) {
      soundManager.stop("dlm_gamble_loop_v1");

      this._bg.visible = true;

      gameController.slotMachine.clearDimSymbolIds();
      this._gambleSpin = resourceManager.get("gambleSpinContainer:GambleSpin");
      this._gambleSpin.visible = false;

      resourceManager.getController("inputOverlord").setState("freespins");
      messageBus.subscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.subscribe("spinner:SpinEventDead", this._doSpinDeadFunc);
      messageBus.subscribe(
        "spinner:WinningLinesEventDead",
        this._payWinsDeadFunc
      );

      gameController.slotMachine.selectReelMode("freespins");

      this._winnings = task.data.bonusWin;
      this._freespinsCount = task.data.freeSpinsAwarded;
      this._introFsCount.setTranslationParameters(this._freespinsCount);
      this._spinsLeft = task.data.freeSpinsAwarded - 1;
      this._fsWinningsMeter.set(
        gameController.preFSReelPrize + task.data.bonusWin
      );
      this._fsCountText.setTranslationParameters(
        this._freespinsCount - this._spinsLeft,
        this._freespinsCount
      );
      this._fsCountText.visible = true;

      this._startHolder = task;
      this._startHolder.join();

      this._fsActive = true;
      this.onOrientationChange();

      soundManager.stop("hc_theme_v1");
      soundManager.play("hc_idle_theme_v1");

      this._freespinElements.forEach(function (element) {
        element.visible = true;
        element.alpha = 0;
      });

      this._introPopup.visible = true;
      this._introPopup.alpha = 0;

      this._introPopupTuneId = soundManager.play("Transition");
      soundManager.setVolume(0, this._introPopupTuneId);

      soundManager.play("hbc_whoosh_v1");
      const self = this;
      timerManager.addTimer(
        1000,
        function (progress) {
          self._freespinElements.forEach(function (element) {
            element.alpha = progress;
          });
          self._popupMaskDimObject.show(true, progress);
          self._introPopup.alpha = progress;
          self._logo.alpha = progress - 1;

          soundManager.setVolume(progress, this._introPopupTuneId);
        },
        function () {
          soundManager.setVolume(1, this._introPopupTuneId);
          self._freespinElements.forEach(function (element) {
            element.alpha = 1;
          });
          self._logo.alpha = 1;
          self._logo.visible = false;

          self._introPopup.alpha = 1;
          self._popupMaskDimObject.show(true, 1);
          self._introPopupButton.interactive = true;
          self.playIntroPopupTitleAnim();
          self._introPopupButton.touchend = self._introPopupButton.mouseup =
            function () {
              soundManager.stop("hc_idle_theme_v1");
              soundManager.stop("Transition");
              self._freespinsTune = soundManager.play("FreespinsMusic");
              self._popupMaskDimObject.show(false);
              self._introPopup.visible = false;
              self._startHolder.leave();
              self._introPopupButton.interactive = false;
              self._introPopupButton.touchend = self._introPopupButton.mouseup =
                function () {};
            };
        }
      );
    }

    onFreespinsStartDead(task) {
      this.getNextSpinOutcome();
    }

    onFreespinsAwardedEnd() {
      gdk.getNextGameOutcome(function () {});
    }

    onFreespinsData(task) {
      console.log("");
    }

    onFreespinsDataDeadEvent(task) {
      this._spinsLeft--;

      if (this._winningsThisSpin > 0) {
        this.getNextSpinOutcome();
      } else {
        const self = this;
        timerManager.addTimer(450, undefined, function () {
          self.getNextSpinOutcome();
        });
      }
    }

    onFreespinsRetriggerEvent(task) {
      this._spinsLeft += task.data.num;
      this._freespinsCount += task.data.num;

      this.updateCountText();
    }

    onFreespinsEndEvent(task) {
      this._endHolder = task;
      this._endHolder.join();

      messageBus.unsubscribe("spinner:SpinEvent", this._doSpinFunc);
      messageBus.unsubscribe(
        "spinner:WinningLinesEventDead",
        this._payWinsDeadFunc
      );
      messageBus.unsubscribe("spinner:SpinEventDead", this._doSpinDeadFunc);

      gameController.slotMachine.selectReelMode("default");

      this._outroPopupWinValue.setText(gdk.formatCurrency(this._winnings));
      this._outroPopup = this._outroPopupWin;
      this._outroPopupButton = this._outroPopupWinButton;

      if (gameController.bigWin.checkBigWin(this._winnings)) {
        const self = this;
        gameController.bigWin.clearSkippedFlag();
        gameController.bigWin.start(this._winnings, function () {
          gameController.winningsContainer.visible = true;
          self.stateMachine.switchState("OUTRO");
        });
      } else {
        this.stateMachine.switchState("OUTRO_POPUP");
      }
    }

    doPayWins(task) {
      this._winningsThisSpin = task.data.totalLineWinnings;
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings;
      if (!this.mushroomWinThisSpin) {
        this._fsWinningsMeter.set(this._winnings);
      } else {
        gameController.winningsContainer.visible = true;
        gameData.winningsMeter.set(this._winnings);
      }
    }

    onMushroomResultsEventDead(task) {
      this._winnings += task.totalMushroomWin;
      this._fsWinningsMeter.set(this._winnings);
    }
  }

  new Freespins();
})();
